import { defineComponent as c, createBlock as r, openBlock as e, withCtx as t, createElementBlock as n, Fragment as a, renderList as f, createVNode as i, createTextVNode as p } from "vue";
import u from "../../../components/DataTable/DataTable.vue.js";
import _ from "../../../components/DataTable/DataTableRow.vue.js";
import m from "../../../components/DataTable/DataTableText.vue.js";
import k from "../../../components/ViewLayout/ViewLayoutCollapse.vue.js";
const d = {
  key: 1,
  class: "text-c-3 bg-b-1 flex min-h-[65px] items-center justify-center border-t px-4 text-sm"
}, B = /* @__PURE__ */ c({
  __name: "ResponseCookies",
  props: {
    cookies: {}
  },
  setup(x) {
    return (s, l) => (e(), r(k, { defaultOpen: !1 }, {
      title: t(() => l[0] || (l[0] = [
        p("Cookies")
      ])),
      default: t(() => [
        (e(), n(a, { key: 0 }, [
          s.cookies.length ? (e(), r(u, {
            key: 0,
            class: "flex-1",
            columns: ["", ""]
          }, {
            default: t(() => [
              (e(!0), n(a, null, f(s.cookies, (o) => (e(), r(_, {
                key: o.name
              }, {
                default: t(() => [
                  i(m, {
                    text: o.name
                  }, null, 8, ["text"]),
                  i(m, {
                    text: o.value
                  }, null, 8, ["text"])
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })) : (e(), n("div", d, " No cookies "))
        ], 64))
      ]),
      _: 1
    }));
  }
});
export {
  B as default
};
